import { DomainEnum } from "../services/enum/environment-enum";
import { currentDomain } from "./general-config";
import { baseUrlsWS } from "../services/base-url/base-urls";
import { deleteCookie } from "./helpers";

const getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  const cookie = cookies.find((c) => c.startsWith(name + "="));
  return cookie ? cookie.split("=")[1] : "";
};

const createCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
};

const ssoHandler = async () => {
  //
  if (currentDomain() === DomainEnum.PDFSIMPLI) {
    await setLegacyCookiePdfsimpli();
  } else if (currentDomain() === DomainEnum.RESUMEBUILD) {
    await setLegacyCookieRb();
  } else if (currentDomain() === DomainEnum.LEGALSIMPLI) {
    await setLegacyCookieLs();
  } else if (currentDomain() === DomainEnum.SIGNSIMPLI) {
    await setLegacyCookieSignSimpli();
  } else if (currentDomain() === DomainEnum.WORKSIMPLI) {
    await setLegacyCookieWS();
    deleteCookie("pdfsimpliauth");
  }
};

const setLegacyCookiePdfsimpli = async () => {
  const legacyTicketCookie = getCookie("legacyTicket");
  const ssopl = getCookie("ssopl");

  let ssoPartnerLoginSignSimpliUrl = "https://signsimpli.com/sso/partner-login";
  let ssoPartnerLoginPDFSimpliUrl = "https://pdfsimpli.com/sso/partner-login";

  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes("test") || hostname.includes("test-sso") || hostname.includes("local")) {
    ssoPartnerLoginSignSimpliUrl = baseUrlsWS.QA.SINGLE_SIGN_ON_SIGNSIMPLI + "partner-login";
    ssoPartnerLoginPDFSimpliUrl = "https://test-app.pdfsimpli.com/sso/partner-login";
  } else if (hostname.includes("staging")) {
    ssoPartnerLoginSignSimpliUrl = "https://staging.signsimpli.com/sso/partner-login";
    ssoPartnerLoginPDFSimpliUrl = "https://staging.pdfsimpli.com/sso/partner-login";
  }

  if (!ssopl && legacyTicketCookie) {
    try {
      const response = await fetch(
        `${ssoPartnerLoginSignSimpliUrl}?legacyTicket=${encodeURIComponent(legacyTicketCookie)}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      // const data = await response.json();
      console.log(response);
      createCookie("ssopl", "yes", 1);
    } catch (error) {
      console.error("SSO Partner Login Error:", error);
    }
    try {
      const response = await fetch(
        `${ssoPartnerLoginPDFSimpliUrl}?legacyTicket=${encodeURIComponent(legacyTicketCookie)}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      // const data = await response.json();
      console.log(response);
      createCookie("ssopl", "yes", 1);
    } catch (error) {
      console.error("SSO Partner Login Error:", error);
    }
  }

  const ssoToken = getCookie("ssoToken");
  const ssosi = getCookie("ssosi");
  const ssosils = getCookie("ssosils");

  if (ssoToken) {
    let ssoSignInUrl = "https://auth-api.worksimpli.io/api/v1/sso/signin";

    if (hostname.includes("test") || hostname.includes("local")) {
      ssoSignInUrl = "https://auth-api-qa.worksimpli.io/api/v1/sso/signin";
    }

    if (!ssosi) {
      try {
        const response = await fetch(`${ssoSignInUrl}?ssoToken=${ssoToken}&portal=resumebuild.com`, {
          method: "GET",
          credentials: "include",
        });

        // const data = await response.json();
        console.log("sso-login-successfully!", response);
        createCookie("ssosi", "yes", 1);
      } catch (error) {
        console.error("SSO ResumeBuild Login Error:", error);
      }
    }

    if (!ssosils) {
      try {
        const response = await fetch(`${ssoSignInUrl}?ssoToken=${ssoToken}&portal=legalsimpli.com`, {
          method: "GET",
          credentials: "include",
        });

        // const data = await response.json();
        console.log("sso-ls-login-successfully!", response);
        createCookie("ssosils", "yes", 1);
      } catch (error) {
        console.error("SSO LegalSimpli Login Error:", error);
      }
    }
  }
};
const setLegacyCookieRb = async () => {
  const legacyTicketCookie = getCookie("legacyTicket");
  const ssopl = getCookie("ssopl");

  let ssoPartnerLoginSignSimpliUrl = "https://signsimpli.com/sso/partner-login";
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes("test") || hostname.includes("test-sso") || hostname.includes("local")) {
    ssoPartnerLoginSignSimpliUrl = baseUrlsWS.QA.SINGLE_SIGN_ON_SIGNSIMPLI + "partner-login";
  } else if (hostname.includes("staging")) {
    ssoPartnerLoginSignSimpliUrl = "https://staging.signsimpli.com/sso/partner-login";
  }
  let ssoPartnerLoginPDFSimpliUrl = "https://pdfsimpli.com/sso/partner-login";
  if (hostname.includes("test") || hostname.includes("local") || hostname.includes("localhost")) {
    ssoPartnerLoginPDFSimpliUrl = "https://test-app.pdfsimpli.com/sso/partner-login";
  }

  if (!ssopl && legacyTicketCookie) {
    try {
      const response = await fetch(
        `${ssoPartnerLoginSignSimpliUrl}?legacyTicket=${encodeURIComponent(legacyTicketCookie)}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      // const data = await response.json();
      console.log(response);
      createCookie("ssopl", "yes", 1);
    } catch (error) {
      console.error("SSO Partner Signsimpli Login Error:", error);
    }
    try {
      const response = await fetch(
        `${ssoPartnerLoginPDFSimpliUrl}?legacyTicket=${encodeURIComponent(legacyTicketCookie)}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      // const data = await response.json();
      console.log(response);
      createCookie("ssopl", "yes", 1);
    } catch (error) {
      console.error("SSO Partner Pdfsimpli Login Error:", error);
    }
  }

  const ssoToken = getCookie("ssoToken");
  const ssosils = getCookie("ssosils");

  if (ssoToken) {
    let ssoSignInUrl = "https://auth-api.worksimpli.io/api/v1/sso/signin";

    if (hostname.includes("test") || hostname.includes("local")) {
      ssoSignInUrl = "https://auth-api-qa.worksimpli.io/api/v1/sso/signin";
    }

    if (!ssosils) {
      try {
        const response = await fetch(`${ssoSignInUrl}?ssoToken=${ssoToken}&portal=legalsimpli.com`, {
          method: "GET",
          credentials: "include",
        });

        // const data = await response.json();
        console.log("sso-ls-login-successfully!", response);
        createCookie("ssosils", "yes", 1);
      } catch (error) {
        console.error("SSO LegalSimpli Login Error:", error);
      }
    }
  }
};
const setLegacyCookieLs = async () => {
  const legacyTicketCookie = getCookie("legacyTicket");
  const ssopl = getCookie("ssopl");

  let ssoPartnerLoginSignSimpliUrl = "https://signsimpli.com/sso/partner-login";
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes("test") || hostname.includes("test-sso") || hostname.includes("local")) {
    ssoPartnerLoginSignSimpliUrl = baseUrlsWS.QA.SINGLE_SIGN_ON_SIGNSIMPLI + "partner-login";
  } else if (hostname.includes("staging")) {
    ssoPartnerLoginSignSimpliUrl = "https://staging.signsimpli.com/sso/partner-login";
  }
  let ssoPartnerLoginPDFSimpliUrl = "https://pdfsimpli.com/sso/partner-login";
  if (hostname.includes("test") || hostname.includes("local") || hostname.includes("localhost")) {
    ssoPartnerLoginPDFSimpliUrl = "https://test-app.pdfsimpli.com/sso/partner-login";
  }

  if (!ssopl && legacyTicketCookie) {
    try {
      const response = await fetch(
        `${ssoPartnerLoginSignSimpliUrl}?legacyTicket=${encodeURIComponent(legacyTicketCookie)}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      // const data = await response.json();
      console.log(response);
      createCookie("ssopl", "yes", 1);
    } catch (error) {
      console.error("SSO Partner Signsimpli Login Error:", error);
    }
    try {
      const response = await fetch(
        `${ssoPartnerLoginPDFSimpliUrl}?legacyTicket=${encodeURIComponent(legacyTicketCookie)}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      // const data = await response.json();
      console.log(response);
      createCookie("ssopl", "yes", 1);
    } catch (error) {
      console.error("SSO Partner Pdfsimpli Login Error:", error);
    }
  }

  const ssoToken = getCookie("ssoToken");
  const ssosi = getCookie("ssosi");

  if (ssoToken) {
    let ssoSignInUrl = "https://auth-api.worksimpli.io/api/v1/sso/signin";

    if (hostname.includes("test") || hostname.includes("local")) {
      ssoSignInUrl = "https://auth-api-qa.worksimpli.io/api/v1/sso/signin";
    }

    if (!ssosi) {
      try {
        const response = await fetch(`${ssoSignInUrl}?ssoToken=${ssoToken}&portal=resumebuild.com`, {
          method: "GET",
          credentials: "include",
        });

        // const data = await response.json();
        console.log("sso-login-successfully!", response);
        createCookie("ssosi", "yes", 1);
      } catch (error) {
        console.error("SSO ResumeBuild Login Error:", error);
      }
    }
  }
};
const setLegacyCookieSignSimpli = async () => {
  let ssoPartnerLoginSignSimpliUrl = "https://signsimpli.com/sso/partner-login";
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes("test") || hostname.includes("test-sso") || hostname.includes("local")) {
    ssoPartnerLoginSignSimpliUrl = baseUrlsWS.QA.SINGLE_SIGN_ON_SIGNSIMPLI + "partner-login";
  } else if (hostname.includes("staging")) {
    ssoPartnerLoginSignSimpliUrl = "https://staging.signsimpli.com/sso/partner-login";
  }

  const legacyTicketCookie = getCookie("legacyTicket");
  const ssopl = getCookie("ssopl");
  if (!ssopl && legacyTicketCookie) {
    try {
      const response = await fetch(
        `${ssoPartnerLoginSignSimpliUrl}?legacyTicket=${encodeURIComponent(legacyTicketCookie)}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      // const data = await response.json();
      console.log(response);
      createCookie("ssopl", "yes", 1);
    } catch (error) {
      console.error("SSO Partner Signsimpli Login Error:", error);
    }
  }

  const ssoToken = getCookie("ssoToken");
  const ssosils = getCookie("ssosils");

  if (ssoToken) {
    let ssoSignInUrl = "https://auth-api.worksimpli.io/api/v1/sso/signin";

    if (hostname.includes("test") || hostname.includes("local")) {
      ssoSignInUrl = "https://auth-api-qa.worksimpli.io/api/v1/sso/signin";
    }

    if (!ssosils) {
      try {
        const response = await fetch(`${ssoSignInUrl}?ssoToken=${ssoToken}&portal=legalsimpli.com`, {
          method: "GET",
          credentials: "include",
        });

        // const data = await response.json();
        console.log("sso-ls-login-successfully!", response);
        createCookie("ssosils", "yes", 1);
      } catch (error) {
        console.error("SSO LegalSimpli Login Error:", error);
      }
    }
  }
};
const setLegacyCookieWS = async () => {
  let ssoPartnerLoginWSUrl = "https://worksimpli.com/sso/partner-login";
  const hostname = window.location.hostname.toLowerCase();

  if (hostname.includes("test") || hostname.includes("local")) {
    ssoPartnerLoginWSUrl = "https://test.worksimpli.com/sso/partner-login";
  } else if (hostname.includes("staging")) {
    ssoPartnerLoginWSUrl = "https://staging.worksimpli.com/sso/partner-login";
  }

  const legacyTicketCookie = getCookie("legacyTicket");
  const ssopl = getCookie("ssopl");
  if (!ssopl && legacyTicketCookie) {
    try {
      const response = await fetch(`${ssoPartnerLoginWSUrl}?legacyTicket=${encodeURIComponent(legacyTicketCookie)}`, {
        method: "GET",
        credentials: "include",
      });

      // const data = await response.json();
      console.log(response);
      createCookie("ssopl", "yes", 1);
    } catch (error) {
      console.error("SSO Partner Signsimpli Login Error:", error);
    }
  }

  const ssoToken = getCookie("ssoToken");
  const ssosils = getCookie("ssosils");

  if (ssoToken) {
    let ssoSignInUrl = "https://auth-api.worksimpli.io/api/v1/sso/signin";

    if (hostname.includes("test") || hostname.includes("local")) {
      ssoSignInUrl = "https://auth-api-qa.worksimpli.io/api/v1/sso/signin";
    }

    if (!ssosils) {
      try {
        const response = await fetch(`${ssoSignInUrl}?ssoToken=${ssoToken}&portal=legalsimpli.com`, {
          method: "GET",
          credentials: "include",
        });

        // const data = await response.json();
        console.log("sso-ls-login-successfully!", response);
        createCookie("ssosils", "yes", 1);
      } catch (error) {
        console.error("SSO LegalSimpli Login Error:", error);
      }
    }
  }
};
export default ssoHandler;
